// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.3 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.visible {
  visibility: visible;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.left-1\\/2 {
  left: 50%;
}
.top-8 {
  top: 2rem;
}
.-z-50 {
  z-index: -50;
}
.z-50 {
  z-index: 50;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-px {
  margin-left: 1px;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mt-16 {
  margin-top: 4rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-8 {
  margin-top: 2rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.w-11\\/12 {
  width: 91.666667%;
}
.w-20 {
  width: 5rem;
}
.w-3\\/5 {
  width: 60%;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-sm {
  max-width: 24rem;
}
.flex-none {
  flex: none;
}
.flex-grow {
  flex-grow: 1;
}
.grow {
  flex-grow: 1;
}
.border-collapse {
  border-collapse: collapse;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-full {
  --tw-translate-y: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-pointer {
  cursor: pointer;
}
.resize {
  resize: both;
}
.list-inside {
  list-style-position: inside;
}
.list-decimal {
  list-style-type: decimal;
}
.appearance-none {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-4 {
  gap: 1rem;
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-l {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-r {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.border {
  border-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-blue-300 {
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-green-300 {
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / var(--tw-border-opacity));
}
.border-red-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity));
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.bg-slate-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.p-2 {
  padding: 0.5rem;
}
.p-4 {
  padding: 1rem;
}
.p-8 {
  padding: 2rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.text-center {
  text-align: center;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.leading-tight {
  line-height: 1.25;
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-red-800 {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline {
  outline-style: solid;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

:root {
  --annotation-toolbar-height: 3em;
}

.screenshot-img {
  max-width: 100%;
  height: auto;
  /* margin: auto; */
  /*pointer-events: none;*/
}

.svg-editor {
  /*user-select: none;*/
  top: 0;
  left: 0;
  position: absolute;
}

.cmd-header {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  border-bottom-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  z-index: 50;
}
.image-container {
  width: 100%;
  position: relative;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.relative-to-center {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

.screenshot_button_base {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}

.screenshot_button_base:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.screenshot_button_base:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.screenshot_button_base:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(243 244 246 / var(--tw-ring-opacity));
}

.screenshot_button_base {
  font-weight: 500;
  border-radius: 0.5rem;
  font-size: 1rem;
  line-height: 1.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  margin-inline-end: 0.25rem;
}

.screenshot_button {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}

.screenshot_button:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.screenshot_button:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.screenshot_button:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(243 244 246 / var(--tw-ring-opacity));
}

.screenshot_button {
  font-weight: 500;
  border-radius: 0.5rem;
  font-size: 1rem;
  line-height: 1.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  margin-inline-end: 0.25rem;
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.screenshot_link {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
  text-decoration-line: underline;
  border-style: none;
  background-image: none;
  padding: 0px;
  font-size: 1.125rem;
  line-height: 1.75rem;
  margin-right: 0.5rem;
}
.screenshot_link:hover {
  opacity: 0.75;
}
#done_clipping {
  border-width: 1px;
  border-radius: 0.5rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity));
}
@keyframes text-color {

  0%, 100% {
    color: #ffa2a2;
  }

  50% {
    color: #9f0712;
  }
}
#done_clipping {
  animation: text-color 2s infinite;
}
#done_clipping:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
#done_clipping {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.screenshot_searchbox {
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  border-width: 1px;
  border-radius: 0.25rem;
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  margin-bottom: 0.25rem;
  margin-right: 0.5rem;
}
.annotation_toolbar_button {
  color: #fff;
  cursor: pointer;
  font-size: .875rem;
  height: var(--annotation-toolbar-height);
  width: var(--annotation-toolbar-height);
  margin-bottom: 1px;
}
.annotation_toolbar_button:hover:enabled {
  border-radius: 15px;
  background-color: rgb(243, 240, 240);
}
button:disabled {
  cursor: not-allowed;
  border-radius: 15px;
  background-color: rgb(214, 216, 217);
}
.atb_selected {
  border-radius: 15px;
  background-color: rgba(173, 220, 248, 0.992) !important;
}

.annotation_toolbar_button svg {
  fill: #0a0000;
  width: 28px;
  height: 28px;
  pointer-events: none;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

.svg-surrounding-box {
  cursor: move;
}
.svg-text {
  font-size: 2em;
  font-family: sans-serif;
  stroke-width: 1 !important;
}

g[name="obj"] {
  stroke-width: 4;
}

.popover {
  position: fixed;
  top: 50%;
  left: 50%;
  max-width: 30%;
  transform: translate(-50%, -50%);
  background-color: rgba(245, 245, 245, 0.8);
  padding: 5px 5px;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
  z-index: 1000;
  font-size: 1.875rem;
  line-height: 2.25rem;
}

.popover_sub {
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.fp_instruction {
  font-size: 1rem;
  line-height: 1.5rem;
  position: fixed;
  top: 5px;
  right: 5px;
  max-width: 420px;
  min-width: 210px;
  background-color: #f5f5f5;
  border: 2px solid #222;
  padding: 5px;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}
.instruction_button {
  align-self: flex-end;
  border-width: 2px;
  border-radius: 0.25rem;
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

.my_dialog {
  position: fixed;
  inset: 0px;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.5;
  align-items: center;
  justify-content: center;
}

.my_dialog_content {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  border-radius: 0.5rem;
  padding: 2rem;
  max-width: 28rem;
  width: 100%;
  margin-left: 1rem;
  margin-right: 1rem;
  position: relative;
}

.login_label {
  display: block;
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
  margin-bottom: 0.5rem;
}

.login_text {
  width: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
  border-radius: 0.5rem;
}

.login_text:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity));
}

.login_button {
  width: 50%;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}

.login_button:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity));
}

.login_button {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
  font-weight: 600;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  border-radius: 0.5rem;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}

.screenshot-item {
  width: 12rem;
  position: relative;
  overflow: hidden;
  border-radius: 0.5rem;
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.screenshot-thumbnail {
  width: 12rem;
  height: 12rem;
  min-width: 12rem;
  -o-object-fit: cover;
     object-fit: cover;
  transition-property: transform;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.group:hover .screenshot-thumbnail {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-brightness: brightness(.75);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.screenshot-tags {
  min-width: 12rem;
  overflow-y: scroll;
  max-height: 36px;
}
.delete-icon {
  cursor: pointer;
}

.tag-list-container {
  position: absolute;
  /* Position absolutely relative to the container */
  right: 0;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.tag-list-toggle {
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 0.375rem;
  /* rounded-md */
  background-color: #e0f2fe;
  /* bg-blue-100 */
  color: #0b527e;
  /* text-blue-800 */
  transition: background-color 0.3s ease;

}

.tag-list-toggle:hover {
  background-color: #b0f2fe;
  /* hover:bg-blue-200 */
}

.tag-list {
  /* Removed fixed width, will expand with content */
  /* max-height and overflow will handle scroll */
  overflow-y: auto;
  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
  opacity: 1;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  border-radius: 0.375rem;
}

.tag-list > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}

.tag-list-item {
  word-wrap: break-word;
  white-space: pre-wrap;
  word-break: break-word;
  align-items: center;
  justify-content: space-between;
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  border-radius: 9999px;
}

.tag-list.collapsed {
  max-height: 0;
  overflow-y: hidden;
  opacity: 0;
}

/* CSS for button-style-fetch-more */
.button-style-fetch-more {
  align-items: center;
  background-color: #fff;
  border-radius: 24px;
  box-shadow: rgba(0, 0, 0, .2) 0 3px 5px -1px,rgba(0, 0, 0, .14) 0 6px 10px 0,rgba(0, 0, 0, .12) 0 1px 18px 0;
  box-sizing: border-box;
  color: #3c4043;
  cursor: pointer;
  display: inline-flex;
  fill: currentcolor;
  font-family: "Google Sans",Roboto,Arial,sans-serif;
  font-size: 14px;
  font-weight: 500;
  height: 48px;
  justify-content: center;
  letter-spacing: .25px;
  line-height: normal;
  max-width: 100%;
  overflow: visible;
  padding: 2px 24px;
  position: relative;
  text-align: center;
  transition: box-shadow 280ms cubic-bezier(.4, 0, .2, 1),opacity 15ms linear 30ms,transform 270ms cubic-bezier(0, 0, .2, 1) 0ms;
  touch-action: manipulation;
  width: auto;
  will-change: transform,opacity;
  z-index: 0;
}

.button-style-fetch-more:hover {
  background: #F6F9FE;
  color: #174ea6;
}

/* Spinner */
.spinner {
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  animation: spinner_spin 2s linear infinite;
  border-top: 0.3rem solid #60a5fa;
  /* Tailwind's blue-400 */
  border-right: 0.3rem solid transparent;
  margin-bottom: 1rem;
}

@keyframes spinner_spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* List page */
.taglist {
  min-width: 180px;
  max-width: 180px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  border-radius: 0.5rem;
  padding: 1rem;
  overflow-y: scroll;
  max-height: 100dvh;
  word-wrap: break-word; /* Prevents overflow in long words. Auto add next lines for long line. */
  overflow-wrap: break-word; /* Modern altenative as word-wrap */
}

/* Detail page */
.add-tag-container {
  display:flex;
  align-items: center; /* Vertically align items */
  gap: 5px; /* Add some gap between input and button */
}

.add-tag-button {
  background-color: white;
  border-color: black;
  color: black; /* Grey color for the close button */
  line-height: 0;  /* Adjust line height to vertically center */
  cursor: pointer;
}

.add-tag-button:hover {
  background-color: #888;
}

.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity));
}

.hover\\:text-red-700:hover {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.focus\\:border-transparent:focus {
  border-color: transparent;
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity));
}

@media (min-width: 768px) {

  .md\\:mt-0 {
    margin-top: 0px;
  }
}

@media (min-width: 1024px) {

  .lg\\:w-1\\/6 {
    width: 16.666667%;
  }
}`, "",{"version":3,"sources":["webpack://./src/screenshot/screenshot.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;KAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,MAAM;EACN,OAAO;EACP,kBAAkB;AACpB;;AAGE;EAAA,eAAY;EACZ,QAAY;EACZ,SAAa;EACb,UAAc;EACd,oBAAW;EAAX,qBAAW;EACX,wBAAiB;EACjB,sBAAsB;EAAtB,yDAAsB;EACtB,kBAAe;EAAf,yDAAe;EACf;AARY;AAWZ;EAAA,WAAa;EACb,kBAAkB;EAClB,yBAAiB;KAAjB,sBAAiB;UAAjB;AAFa;AAIf;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;;AAGE;EAAA,kBAAe;EAAf,yDAAe;EACf,iBAAa;EACb,sBAAsB;EAAtB;AAFe;;AAGf;EAAA,8BAAyB;EAAzB;AAAyB;;AACzB;EAAA,kBAAwB;EAAxB;AAAwB;;AACxB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB,4FAAmB;EACnB,oBAA0B;EAA1B;AADmB;;AAEnB;EAAA,gBAAkB;EAClB,qBAAiB;EACjB,eAAgB;EAAhB,mBAAgB;EAChB,oBAAW;EAAX,qBAAW;EACX;AAJkB;;AAQlB;EAAA,kBAA6B;EAA7B,yDAA6B;EAA7B,iBAA6B;EAA7B,sBAA6B;EAA7B;AAA6B;;AAA7B;EAAA,8BAA6B;EAA7B;AAA6B;;AAA7B;EAAA,kBAA6B;EAA7B;AAA6B;;AAA7B;EAAA,2GAA6B;EAA7B,yGAA6B;EAA7B,4FAA6B;EAA7B,oBAA6B;EAA7B;AAA6B;;AAA7B;EAAA,gBAA6B;EAA7B,qBAA6B;EAA7B,eAA6B;EAA7B,mBAA6B;EAA7B,oBAA6B;EAA7B,qBAA6B;EAA7B,0BAA6B;EAC7B,oBAAoB;EAApB;AAD6B;AAI7B;EAAA,oBAA8B;EAA9B,+CAA8B;EAA9B,+BAA8B;EAC9B,kBAA8B;EAA9B,sBAA8B;EAA9B,YAA8B;EAC9B,mBAAc;EAAd,oBAAc;EACd;AAH8B;AAM9B;EAAA;AAAiB;AAGjB;EAAA,iBAAa;EACb,qBAAiB;EACjB,mBAAc;EAAd,oBAAc;EACd,oBAAmB;EAAnB,8CAAmB;EACnB,kBAAoB;EAApB;AAJa;AAKb;;EAAA;IAAA;EAAyB;;EAAzB;IAAA;EAAyB;AAAA;AAAzB;EAAA;AAAyB;AACzB;EAAA,kBAAwB;EAAxB;AAAwB;AACxB;EAAA,oBAAW;EAAX,uBAAW;EACX,oBAAW;EAAX;AADW;;AAKX;EAAA,kBAAW;EAAX,mBAAW;EACX,mBAAW;EAAX,sBAAW;EACX,iBAAa;EACb,sBAAc;EACd,0EAAa;EAAb,8FAAa;EAAb,uGAAa;EACb,sBAAW;EACX;AANW;AAQb;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,wCAAwC;EACxC,uCAAuC;EACvC,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;AACtC;AACA;EACE,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kBAAyB;EAAzB,SAAyB;EAAzB,2BAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,cAAc;EACd,gCAAgC;EAChC,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,mBAAe;EAAf,oBAAe;AACjB;;AAGE;EAAA,mBAAc;EAAd;AAAc;;AAId;EAAA,eAAgB;EAAhB,mBAAgB;EAChB,eAAe;EACf,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB;AAVgB;AAahB;EAAA,oBAAe;EACf,iBAAe;EACf,sBAAc;EACd,sBAAmB;EAAnB;AAHe;;AAOf;EAAA,eAAY;EACZ,UAAc;EACd,mDAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB;AALY;;AASZ;EAAA,kBAAe;EAAf,yDAAe;EACf,qBAAiB;EACjB,aAAU;EACV,gBAAe;EACf,WAAa;EACb,iBAAW;EAAX,kBAAW;EACX;AANe;;AAUf;EAAA,cAAY;EACZ,oBAAoB;EAApB,6CAAoB;EACpB;AAFY;;AAMZ;EAAA,WAAa;EACb,kBAAW;EAAX,mBAAW;EACX,mBAAW;EAAX,sBAAW;EACX,iBAAa;EACb,sBAAsB;EAAtB,yDAAsB;EACtB;AALa;;AAMb;EAAA,8BAAyB;EAAzB,mBAAyB;EACzB,2GAAmB;EAAnB,yGAAmB;EAAnB,4FAAmB;EACnB,oBAA0B;EAA1B;AAFyB;;AAMzB;EAAA,UAAY;EACZ,oBAAW;EAAX,qBAAW;EACX,kBAAkB;EAAlB;AAFY;;AAGZ;EAAA,kBAAwB;EAAxB;AAAwB;;AACxB;EAAA,oBAAiB;EAAjB,gDAAiB;EACjB,gBAAoB;EACpB,mBAAW;EAAX,sBAAW;EACX,qBAAiB;EACjB,gKAAiB;EAAjB,wJAAiB;EAAjB,iLAAiB;EAAjB,wDAAiB;EACjB;AALiB;;AASjB;EAAA,YAAW;EACX,kBAAe;EACf,gBAAsB;EACtB,qBAAiB;EACjB,+EAAgB;EAAhB,mGAAgB;EAAhB;AAJW;AAOX;EAAA,YAAc;EAAd,aAAc;EACd,gBAAe;EACf,oBAAmB;KAAnB,iBAAmB;EACnB,8BAA2B;EAC3B,0BAAmB;EACnB;AALc;AAMd;EAAA,iBAA4B;EAA5B,iBAA4B;EAA5B,+LAA4B;EAC5B,gCAAgC;EAAhC;AAD4B;AAI5B;EAAA,gBAAe;EACf,kBAAwB;EACxB;AAFe;AAIjB;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,QAAQ;EACR,oBAAW;EAAX,qBAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sCAAsC;;AAExC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kDAAkD;EAClD,+CAA+C;EAC/C,gBAAgB;EAChB,iEAAiE;EACjE,UAAU;EACV,kBAAe;EAAf,yDAAe;EACf,6EAAgB;EAAhB,iGAAgB;EAAhB,uGAAgB;EAChB,uBAAiB;AAEnB;;AADE;EAAA,uBAAgB;EAAhB,8DAAgB;EAAhB;AAAgB;;AAGlB;EACE,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,8BAAsB;EACtB,kBAAoB;EAApB,yDAAoB;EACpB,oBAAsB;EAAtB,8CAAsB;EACtB,qBAAW;EAAX,sBAAW;EACX,mBAAW;EAAX,sBAAW;EACX,qBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,4GAA4G;EAC5G,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,kDAAkD;EAClD,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,8HAA8H;EAC9H,0BAA0B;EAC1B,WAAW;EACX,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,gCAAgC;EAChC,wBAAwB;EACxB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,cAAc;AAEZ;EAAA,gBAAoB;EACpB,gBAAoB;EACpB,kBAAe;EAAf,yDAAe;EACf,6EAAgB;EAAhB,iGAAgB;EAAhB,uGAAgB;EAChB,qBAAiB;EACjB,aAAU;EACV,kBAAwB;EACxB,kBAAgB;EAChB,qBAAqB,EAAE,wEAAwE;EAC/F,yBAAyB,EAAE,mCAAmC;AAT1C;;AAYtB,gBAAgB;AAChB;EACE,YAAY;EACZ,mBAAmB,EAAE,2BAA2B;EAChD,QAAQ,EAAE,0CAA0C;AACtD;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY,EAAE,oCAAoC;EAClD,cAAc,GAAG,4CAA4C;EAC7D,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAzYA;EAAA,kBAyYC;EAzYD;AAyYC;;AAzYD;EAAA,kBAyYC;EAzYD;AAyYC;;AAzYD;EAAA,kBAyYC;EAzYD;AAyYC;;AAzYD;EAAA,oBAyYC;EAzYD;AAyYC;;AAzYD;EAAA;AAyYC;;AAzYD;EAAA;AAyYC;;AAzYD;EAAA,8BAyYC;EAzYD;AAyYC;;AAzYD;EAAA,2GAyYC;EAzYD,yGAyYC;EAzYD;AAyYC;;AAzYD;EAAA,oBAyYC;EAzYD;AAyYC;;AAzYD;;EAAA;IAAA;EAyYC;AAAA;;AAzYD;;EAAA;IAAA;EAyYC;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n:root {\n  --annotation-toolbar-height: 3em;\n}\n\n.screenshot-img {\n  max-width: 100%;\n  height: auto;\n  /* margin: auto; */\n  /*pointer-events: none;*/\n}\n\n.svg-editor {\n  /*user-select: none;*/\n  top: 0;\n  left: 0;\n  position: absolute;\n}\n\n.cmd-header {\n  @apply fixed;\n  @apply top-0;\n  @apply left-0;\n  @apply right-0;\n  @apply px-2;\n  @apply border-b-2;\n  @apply border-gray-300;\n  @apply bg-white;\n  @apply z-50;\n}\n.image-container {\n  @apply w-full;\n  position: relative;\n  user-select: none;\n}\n.relative-to-center {\n  position: relative;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.screenshot_button_base {\n  @apply bg-white;\n  @apply border;\n  @apply border-gray-300;\n  @apply focus:outline-none;\n  @apply hover:bg-gray-100;\n  @apply focus:ring-4;\n  @apply focus:ring-gray-100;\n  @apply font-medium;\n  @apply rounded-lg;\n  @apply text-base;\n  @apply px-2;\n  @apply me-1;\n}\n\n.screenshot_button {\n  @apply screenshot_button_base;\n  @apply text-gray-900;\n}\n.screenshot_link {\n  @apply text-blue-500 underline;\n  @apply bg-none border-none p-0;\n  @apply text-lg;\n  @apply mr-2;\n}\n.screenshot_link:hover {\n  @apply opacity-75;\n}\n#done_clipping {\n  @apply border;\n  @apply rounded-lg;\n  @apply text-lg;\n  @apply text-red-500;\n  @apply bg-yellow-100;\n  @apply animate-text-color;\n  @apply hover:bg-gray-100;\n  @apply py-1;\n  @apply px-2;\n}\n\n.screenshot_searchbox {\n  @apply px-4;\n  @apply py-2;\n  @apply border;\n  @apply rounded;\n  @apply shadow;\n  @apply mb-1;\n  @apply mr-2;\n}\n.annotation_toolbar_button {\n  color: #fff;\n  cursor: pointer;\n  font-size: .875rem;\n  height: var(--annotation-toolbar-height);\n  width: var(--annotation-toolbar-height);\n  margin-bottom: 1px;\n}\n.annotation_toolbar_button:hover:enabled {\n  border-radius: 15px;\n  background-color: rgb(243, 240, 240);\n}\nbutton:disabled {\n  cursor: not-allowed;\n  border-radius: 15px;\n  background-color: rgb(214, 216, 217);\n}\n.atb_selected {\n  border-radius: 15px;\n  background-color: rgba(173, 220, 248, 0.992) !important;\n}\n\n.annotation_toolbar_button svg {\n  fill: #0a0000;\n  width: 28px;\n  height: 28px;\n  pointer-events: none;\n  @apply relative-to-center;\n}\n\n.svg-surrounding-box {\n  cursor: move;\n}\n.svg-text {\n  font-size: 2em;\n  font-family: sans-serif;\n  stroke-width: 1 !important;\n}\n\ng[name=\"obj\"] {\n  stroke-width: 4;\n}\n\n.popover {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  max-width: 30%;\n  transform: translate(-50%, -50%);\n  background-color: rgba(245, 245, 245, 0.8);\n  padding: 5px 5px;\n  border-radius: 5px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);\n  z-index: 1000;\n  @apply text-3xl;\n}\n\n.popover_sub {\n  @apply text-lg;\n}\n\n.fp_instruction {\n  @apply text-base;\n  position: fixed;\n  top: 5px;\n  right: 5px;\n  max-width: 420px;\n  min-width: 210px;\n  background-color: #f5f5f5;\n  border: 2px solid #222;\n  padding: 5px;\n  border-radius: 10px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n.instruction_button {\n  @apply self-end;\n  @apply border-2;\n  @apply rounded;\n  @apply border-black;\n}\n\n.my_dialog {\n  @apply fixed;\n  @apply inset-0;\n  @apply bg-black;\n  @apply bg-opacity-50;\n  @apply items-center;\n  @apply justify-center;\n}\n\n.my_dialog_content {\n  @apply bg-white;\n  @apply rounded-lg;\n  @apply p-8;\n  @apply max-w-md;\n  @apply w-full;\n  @apply mx-4;\n  @apply relative;\n}\n\n.login_label {\n  @apply block;\n  @apply text-gray-700;\n  @apply mb-2;\n}\n\n.login_text {\n  @apply w-full;\n  @apply px-4;\n  @apply py-2;\n  @apply border;\n  @apply border-gray-300;\n  @apply rounded-lg;\n  @apply focus:outline-none;\n  @apply focus:ring-2;\n  @apply focus:ring-blue-500;\n}\n\n.login_button {\n  @apply w-1/2;\n  @apply mx-1;\n  @apply bg-blue-500;\n  @apply hover:bg-blue-600;\n  @apply text-white;\n  @apply font-semibold;\n  @apply py-2;\n  @apply rounded-lg;\n  @apply transition;\n  @apply duration-300;\n}\n\n.screenshot-item {\n  @apply w-48;\n  @apply relative;\n  @apply overflow-hidden;\n  @apply rounded-lg;\n  @apply shadow-lg;\n}\n.screenshot-thumbnail {\n  @apply size-48;\n  @apply min-w-48;\n  @apply object-cover;\n  @apply transition-transform;\n  @apply duration-300;\n  @apply ease-in-out;\n  @apply group-hover:scale-110;\n  @apply group-hover:brightness-75;\n}\n.screenshot-tags {\n  @apply min-w-48;\n  @apply overflow-y-scroll;\n  max-height: 36px;\n}\n.delete-icon {\n  cursor: pointer;\n}\n\n.tag-list-container {\n  position: absolute;\n  /* Position absolutely relative to the container */\n  right: 0;\n  @apply px-2;\n}\n\n.tag-list-toggle {\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 0.375rem;\n  /* rounded-md */\n  background-color: #e0f2fe;\n  /* bg-blue-100 */\n  color: #0b527e;\n  /* text-blue-800 */\n  transition: background-color 0.3s ease;\n\n}\n\n.tag-list-toggle:hover {\n  background-color: #b0f2fe;\n  /* hover:bg-blue-200 */\n}\n\n.tag-list {\n  /* Removed fixed width, will expand with content */\n  /* max-height and overflow will handle scroll */\n  overflow-y: auto;\n  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;\n  opacity: 1;\n  @apply bg-white;\n  @apply shadow-md;\n  @apply rounded-md;\n  @apply space-y-2;\n}\n\n.tag-list-item {\n  word-wrap: break-word;\n  white-space: pre-wrap;\n  word-break: break-word;\n  @apply items-center;\n  @apply justify-between;\n  @apply bg-indigo-100;\n  @apply text-indigo-800;\n  @apply px-3;\n  @apply py-2;\n  @apply rounded-full;\n}\n\n.tag-list.collapsed {\n  max-height: 0;\n  overflow-y: hidden;\n  opacity: 0;\n}\n\n/* CSS for button-style-fetch-more */\n.button-style-fetch-more {\n  align-items: center;\n  background-color: #fff;\n  border-radius: 24px;\n  box-shadow: rgba(0, 0, 0, .2) 0 3px 5px -1px,rgba(0, 0, 0, .14) 0 6px 10px 0,rgba(0, 0, 0, .12) 0 1px 18px 0;\n  box-sizing: border-box;\n  color: #3c4043;\n  cursor: pointer;\n  display: inline-flex;\n  fill: currentcolor;\n  font-family: \"Google Sans\",Roboto,Arial,sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  height: 48px;\n  justify-content: center;\n  letter-spacing: .25px;\n  line-height: normal;\n  max-width: 100%;\n  overflow: visible;\n  padding: 2px 24px;\n  position: relative;\n  text-align: center;\n  transition: box-shadow 280ms cubic-bezier(.4, 0, .2, 1),opacity 15ms linear 30ms,transform 270ms cubic-bezier(0, 0, .2, 1) 0ms;\n  touch-action: manipulation;\n  width: auto;\n  will-change: transform,opacity;\n  z-index: 0;\n}\n\n.button-style-fetch-more:hover {\n  background: #F6F9FE;\n  color: #174ea6;\n}\n\n/* Spinner */\n.spinner {\n  border-radius: 50%;\n  width: 3rem;\n  height: 3rem;\n  animation: spinner_spin 2s linear infinite;\n  border-top: 0.3rem solid #60a5fa;\n  /* Tailwind's blue-400 */\n  border-right: 0.3rem solid transparent;\n  margin-bottom: 1rem;\n}\n\n@keyframes spinner_spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* List page */\n.taglist {\n  @apply min-w-[180px];\n  @apply max-w-[180px];\n  @apply bg-white;\n  @apply shadow-md;\n  @apply rounded-lg;\n  @apply p-4;\n  @apply overflow-y-scroll;\n  @apply max-h-dvh;\n  word-wrap: break-word; /* Prevents overflow in long words. Auto add next lines for long line. */\n  overflow-wrap: break-word; /* Modern altenative as word-wrap */\n}\n\n/* Detail page */\n.add-tag-container {\n  display:flex;\n  align-items: center; /* Vertically align items */\n  gap: 5px; /* Add some gap between input and button */\n}\n\n.add-tag-button {\n  background-color: white;\n  border-color: black;\n  color: black; /* Grey color for the close button */\n  line-height: 0;  /* Adjust line height to vertically center */\n  cursor: pointer;\n}\n\n.add-tag-button:hover {\n  background-color: #888;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
